query GetAddressesForAccount(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  addressesForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        firstName
        lastName
        businessName
        primaryEmail
        primaryPhoneNumber
        primaryWebsite

        address1
        address2
        city
        stateCode
        zipCode
        countryCode

        insertedAt
        updatedAt

        account {
          id
        }
      }
    }
  }
}
